import {
    BoxHeader,
    BoxTitle,
} from '../../pages/home/homeElements'
import {
    NewsHotBoxWrap,
    NewsHotList,
    NewsHotItem,
    NewsHotImageLink,
    NewsHotImage,
    NewsHotBody,
    NewsHotTitle,
    NewsHotDate,
    Number
} from './NewsHotBoxElements'
import { useEffect, useState } from 'react';
import newsApi from '../../api/newsApi'
import moment from 'moment'

const NewsHotBox = ({type, category, sticky}) => {

    const [news, setNews] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const getNews = async () => {
            
            const response = type==='view'? 
            await newsApi.getMostViewNews({_limit: 5, category }) :
            await newsApi.getNewsFromCategory({_limit: 5, category })
            setNews(response.news)
            setLoading(false)
        }

        getNews()
    },[category, type])

    if(loading) return <></>


    return (
        <NewsHotBoxWrap sticky={sticky}>
            <BoxHeader>
                <BoxTitle  to='/'>{type==='view'?`Xem nhiều${category ? ` - ${category}`:''}`:'Cùng loại'}</BoxTitle>
            </BoxHeader>
            <NewsHotList>
                {news?.map((news, index) => (
                    <NewsHotItem key={news._id}>
                        <NewsHotImageLink title={news.title} to={`/news/${news._id}`}>
                            <NewsHotImage src={news.image} alt={news.title} />
                            {type === 'view' && <Number>{index + 1}</Number>}
                        </NewsHotImageLink>
                        <NewsHotBody>
                            <NewsHotTitle title={news.title} to={`/news/${news._id}`}>{news.title}</NewsHotTitle>
                            <NewsHotDate className='hide-on-mobile-tablet'>{moment(news.createdAt).fromNow()}</NewsHotDate>
                        </NewsHotBody>
                    </NewsHotItem>
                ))}
            </NewsHotList>
        </NewsHotBoxWrap>
    )
}

export default NewsHotBox
